import React from "react";

import Draggable, { DraggableData, DraggableEvent } from "react-draggable";
import { Preview } from "@creatomate/preview";

interface WorkingAreaSeparatorProps {
  draggablePositionY: number;
  onDraggablePositionYChange: (value: number) => void;
  preview: Preview;
}

const WorkingAreaSeparator: React.FC<WorkingAreaSeparatorProps> = ({
  draggablePositionY, onDraggablePositionYChange, preview
}) => {
  const handleTimelineDragging = (_: DraggableEvent, data: DraggableData, isDragging: boolean) => {
    onDraggablePositionYChange(data.y);
    // eslint-disable-next-line no-param-reassign
    preview.element.style.pointerEvents = isDragging ? "none" : "auto";
  };

  return (
    <Draggable
      axis="y"
      bounds={{ left: 0, top: -400, bottom: 200, right: 0 }}
      onDrag={(event, data) => { handleTimelineDragging(event, data, true); }}
      onStop={(event, data) => { handleTimelineDragging(event, data, false); }}
      defaultPosition={{ x: 0, y: 0 }}
      position={{ x: 0, y: draggablePositionY }}
      scale={1}
    >
      <div className="WorkingArea-Draggable" />
    </Draggable>
  );
};

export default WorkingAreaSeparator;
